import { useMemo, useState } from "react";
import { IActionPlan } from "entities/RCA/ActionPlanEntity/ActionPlanEntityInterfaces";
import { useActionPlansEditionContext } from "../../context/ActionPlansEditionContext";
import { NAME_MAX_INPUT_RCA_ACTION_PLAN } from "constants/constants";

interface IUseActionPlanNameCellResult {
    isEditing: boolean;
    name: string;
    handleNameChange: (value: string) => void;
    maxLength: number;
    currentLength: number;
}

export const useActionPlanNameCell = (row: IActionPlan): IUseActionPlanNameCellResult => {
    const { edit, setEdit } = useActionPlansEditionContext();

    const existingEdition = useMemo(() => edit.findIndex((e) => e.id === row.action_plan_id), [edit, row]);
    const nameChanges = useMemo(
        () => (existingEdition !== -1 ? edit[existingEdition]?.changes?.name : undefined),
        [edit, existingEdition],
    );

    const initialName = nameChanges !== undefined ? nameChanges : row.name || "";
    const [name, setName] = useState<string>(initialName);

    const handleNameChange = (value: string) => {
        setName(value);

        if (existingEdition !== -1) {
            setEdit((prevEdit) => {
                const newEdit = [...prevEdit];
                newEdit[existingEdition] = {
                    ...newEdit[existingEdition],
                    changes: {
                        ...newEdit[existingEdition]?.changes,
                        name: value,
                    },
                };
                return newEdit;
            });
        }
    };

    const isEditing = existingEdition !== -1;

    return {
        isEditing,
        name,
        handleNameChange,
        maxLength: NAME_MAX_INPUT_RCA_ACTION_PLAN,
        currentLength: name.length,
    };
};
